import { render, staticRenderFns } from "./SistemaQExamCreate.vue?vue&type=template&id=327184df"
import script from "./SistemaQExamCreate.vue?vue&type=script&lang=js"
export * from "./SistemaQExamCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports